import { render, staticRenderFns } from "./goods-return-list.vue?vue&type=template&id=9c83e32c&"
import script from "./goods-return-list.vue?vue&type=script&lang=js&"
export * from "./goods-return-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports